import '/assets/styles/sections/header/header-checkout.scss';
import classNames from 'classnames';
import { useMemo } from 'react';

// Partials
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Img from '@wearetla/tla-essentials-tools/partials/img';
import Btn from '/views/partials/btn';

// Context
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useTranslation } from '/utilities/i18n';

// Static Assets
import image_logo from '/assets/images/logo-white.svg';

export const CheckoutHeader = () => {
	const { activeRoute } = useNavigator();
	const { t } = useTranslation();

	const step = useMemo(() => activeRoute?.checkoutStep ?? 1, [activeRoute]);

	return (
		<header className="section header-checkout">
			<div className="wrapper header-wrap">
				<Link href="home" className="header-logo">
					<Img className="logo-image" alt="Logo" src={image_logo} />
				</Link>

				<div className="header-steps">
					<div className={classNames('steps-step', { active: step === 1 })}>
						<Link href="checkout">{t('Bilet Seçimi')}</Link>
					</div>
					<hr className="steps-separator" />
					<div className={classNames('steps-step', { active: step === 2 })}>{t('Ödeme')}</div>
					<hr className="steps-separator" />
					<div className={classNames('steps-step', { active: step === 3 })}>{t('Hesap Özeti')}</div>
				</div>

				<Btn tag="link" href="home" className="header-backbtn text outline" icon="arrow-left">
					{t('Ana Sayfaya Geri Dön')}
				</Btn>
			</div>
		</header>
	);
};

export default CheckoutHeader;
